import { render, staticRenderFns } from "./CameraRecipientCreateModal.vue?vue&type=template&id=b0f1483a&"
import script from "./CameraRecipientCreateModal.vue?vue&type=script&lang=js&"
export * from "./CameraRecipientCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports